import { jsxs as b, jsx as n } from "react/jsx-runtime";
import { QUERIES as B } from "@fcamna/shared-component-foundations";
import { useMemo as F, useState as A, useRef as Q, useEffect as H } from "react";
import l from "styled-components";
import { u as K } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import { b as U } from "./useSlots-a1aa6a84.mjs";
import { Button as O } from "./button.js";
import { D as z } from "./index-2be68378.mjs";
import { Icon as g } from "./icon.js";
import { TextInput as G } from "./textInput.js";
import { u as E } from "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import { u as J } from "./uniqueId-321287e8.mjs";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
import "./useWindowSize-88e90e04.mjs";
import "./checkbox.js";
import "./label-33699561.mjs";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./closeButton.js";
import "./iconButton.js";
import "@fcamna/shared-icons";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
import "./helperText-d9646f54.mjs";
import "./menu.js";
import "./radio.js";
const W = "...", V = (t, s) => {
  const p = s - t + 1;
  return Array.from({ length: p }, ($, m) => m + t);
}, X = ({ totalCount: t, siblingCount: s = 1, currentPage: p }) => F(() => {
  if (s + 5 >= t)
    return V(1, t);
  const f = Math.max(p - s, 1), h = Math.min(p + s, t), c = f > 1, o = h < t - 1, i = 1, u = t;
  if (!c && o) {
    const a = 3 + 2 * s;
    return [...V(1, a - 2), W, t];
  }
  if (c && !o) {
    const a = 3 + 2 * s, P = V(t - a + 3, t);
    return [i, W, ...P];
  }
  if (c && o) {
    const a = V(f + 1, h - 1);
    return [i, W, ...a, W, u];
  }
}, [t, s, p]), q = l.div`
  display: ${(t) => t.theme.components.pagination.MobileWrapper.display};
  justify-content: ${(t) => t.theme.components.pagination.MobileWrapper.justifyContent};
  align-items: ${(t) => t.theme.components.pagination.MobileWrapper.alignItems};
  @media ${B.tabletAndUp} {
    display: ${(t) => t.theme.components.pagination.MobileWrapper.tabletAndUp.display};
  }
`, Y = l(q)`
  gap: ${(t) => t.theme.components.pagination.MobileWithButton.gap};
  @media ${B.mobile} {
    max-width: ${(t) => t.theme.components.pagination.MobileWithButton.mobile.maxWidth};
  }
  && > button {
    min-width: ${(t) => t.theme.components.pagination.MobileWithButton.button.minWidth};
    min-height: ${(t) => t.theme.components.pagination.MobileWithButton.button.minHeight};
    padding: ${(t) => t.theme.components.pagination.MobileWithButton.button.padding};
    font-family: ${(t) => t.theme.components.pagination.MobileWithButton.button.fontFamily};
    font-size: ${(t) => t.theme.components.pagination.MobileWithButton.button.fontSize};
    font-weight: ${(t) => t.theme.components.pagination.MobileWithButton.button.fontWeight};
    line-height: ${(t) => t.theme.components.pagination.MobileWithButton.button.lineHeight};
    gap: ${(t) => t.theme.components.pagination.MobileWithButton.button.gap};
    > div {
      margin: ${(t) => t.theme.components.pagination.MobileWithButton.button.div.margin};
    }
  }
`, Z = l(q)`
  gap: ${(t) => t.theme.components.pagination.MobileDefaultView.gap};
`, tt = l.span`
  width: ${(t) => t.theme.components.pagination.TextWrapper.width};
  display: ${(t) => t.theme.components.pagination.TextWrapper.display};
  justify-content: ${(t) => t.theme.components.pagination.TextWrapper.justifyContent};
  font-family: ${(t) => t.theme.components.pagination.TextWrapper.fontFamily};
  font-size: ${(t) => t.theme.components.pagination.TextWrapper.fontSize};
  font-weight: ${(t) => t.theme.components.pagination.TextWrapper.fontWeight};
  line-height: ${(t) => t.theme.components.pagination.TextWrapper.lineHeight};
  color: ${(t) => t.theme.components.pagination.TextWrapper.color};
`, et = l.ul`
  display: ${(t) => t.theme.components.pagination.ListWrapper.display};
  margin: ${(t) => t.theme.components.pagination.ListWrapper.margin};
  padding: ${(t) => t.theme.components.pagination.ListWrapper.padding};
  @media ${B.tabletAndUp} {
    display: ${(t) => t.theme.components.pagination.ListWrapper.tabletAndUp.display};
    align-items: ${(t) => t.theme.components.pagination.ListWrapper.tabletAndUp.alignItems};
    list-style-type: ${(t) => t.theme.components.pagination.ListWrapper.tabletAndUp.listStyleType};
    gap: ${(t) => t.theme.components.pagination.ListWrapper.tabletAndUp.gap};
  }
`, M = l.li`
  height: ${(t) => t.theme.components.pagination.ListItem.height};
  width: ${(t) => t.theme.components.pagination.ListItem.width};
`, N = l.button`
  padding: ${(t) => t.theme.components.pagination.NavButton.padding};
  display: ${(t) => t.theme.components.pagination.NavButton.display};
  align-items: ${(t) => t.theme.components.pagination.NavButton.alignItems};
  justify-content: ${(t) => t.theme.components.pagination.NavButton.justifyContent};
  background-color: ${(t) => t.theme.components.pagination.NavButton.backgroundColor};
  border-radius: ${(t) => t.theme.components.pagination.NavButton.borderRadius};
  cursor: ${(t) => t.theme.components.pagination.NavButton.cursor};
  color: ${(t) => t.theme.components.pagination.NavButton.color};
  border: ${(t) => t.theme.components.pagination.NavButton.border};

  &:focus-visible {
    outline: ${(t) => t.theme.components.pagination.NavButton.focusVisible.outline};
  }

  &:disabled {
    cursor: ${(t) => t.theme.components.pagination.NavButton.disabled.cursor};
    color: ${(t) => t.theme.components.pagination.NavButton.disabled.color};
  }

  &:hover:not([disabled]) {
    background-color: ${(t) => t.theme.components.pagination.NavButton.hoverNotDisabled.backgroundColor};
  }
`, nt = l.a`
  display: ${(t) => t.theme.components.pagination.PageLink.display};
  align-items: ${(t) => t.theme.components.pagination.PageLink.alignItems};
  justify-content: ${(t) => t.theme.components.pagination.PageLink.justifyContent};
  padding: ${(t) => t.theme.components.pagination.PageLink.padding};
  cursor: ${(t) => t.theme.components.pagination.PageLink.cursor};
  border-radius: ${(t) => t.theme.components.pagination.PageLink.borderRadius};
  color: ${(t) => t.theme.components.pagination.PageLink.color};
  font-family: ${(t) => t.theme.components.pagination.PageLink.fontFamily};
  font-size: ${(t) => t.theme.components.pagination.PageLink.fontSize};
  font-weight: ${(t) => t.theme.components.pagination.PageLink.fontWeight};
  line-height: ${(t) => t.theme.components.pagination.PageLink.lineHeight};
  &:focus-visible {
    ${(t) => !t.$isActive && `outline: ${t.theme.components.pagination.PageLink.focusVisible.active.outline};
       outline-offset: ${t.theme.components.pagination.PageLink.focusVisible.active.outlineOffset};
    `}
  }

  ${(t) => {
  if (t.$isActive)
    return `
    background-color: ${t.theme.components.pagination.PageLink.isActive.backgroundColor};
    color: ${t.theme.components.pagination.PageLink.isActive.color};
    `;
}};
  &:hover {
    background-color: ${(t) => {
  if (!t.$isActive)
    return t.theme.components.pagination.PageLink.hover.backgroundColor.active;
}};
  }
`, it = l.span`
  display: ${(t) => t.theme.components.pagination.DotsContainer.display};
  align-items: ${(t) => t.theme.components.pagination.DotsContainer.alignItems};
  justify-content: ${(t) => t.theme.components.pagination.DotsContainer.justifyContent};
  height: ${(t) => t.theme.components.pagination.DotsContainer.height};
  width: ${(t) => t.theme.components.pagination.DotsContainer.width};
  border-radius: ${(t) => t.theme.components.pagination.DotsContainer.borderRadius};
  color: ${(t) => t.theme.components.pagination.DotsContainer.color};
  padding: ${(t) => t.theme.components.pagination.DotsContainer.padding};
  box-sizing: ${(t) => t.theme.components.pagination.DotsContainer.boxSizing};
  && > svg {
    transform: ${(t) => t.theme.components.pagination.DotsContainer.svg.transform};
  }
`, ot = l.div`
  ${(t) => `
    display: ${t.theme.components.dataTable.TablePaginationView.Wrapper.display};
    flex-direction: ${t.theme.components.dataTable.TablePaginationView.Wrapper.flexDirection};
    justify-content: ${t.$singleChild && t.theme.components.dataTable.TablePaginationView.Wrapper.onlyChild.justifyContent || t.theme.components.dataTable.TablePaginationView.Wrapper.justifyContent};
    gap: ${t.theme.components.dataTable.TablePaginationView.Wrapper.gap};
    @media ${B.tabletAndUp} {
      flex-direction: ${t.theme.components.dataTable.TablePaginationView.Wrapper.tabletView.flexDirection}
    `}
`, at = l.div`
  ${(t) => `
    display: ${t.theme.components.dataTable.TablePaginationView.Container.display};
    flex-direction: ${t.theme.components.dataTable.TablePaginationView.Container.flexDirection};
    justify-content: ${t.theme.components.dataTable.TablePaginationView.Container.justifyContent};
    align-items: ${t.theme.components.dataTable.TablePaginationView.Container.alignItems};
    gap: ${t.theme.components.dataTable.TablePaginationView.Container.gap};
    .Pagniation__Control {
      width: ${t.theme.components.dataTable.TablePaginationView.Container.paginationControl.width};
      min-width: ${t.theme.components.dataTable.TablePaginationView.Container.paginationControl.minWidth};
    }
    .DropdownBase__wrapper {
      width: ${t.theme.components.dataTable.TablePaginationView.Container.paginationControl.width};
    }
    @media ${B.tabletAndUp} {
      flex-direction: ${t.theme.components.dataTable.TablePaginationView.Container.tabletView.flexDirection};
      justify-content: ${t.theme.components.dataTable.TablePaginationView.Container.tabletView.justifyContent};
      width: ${t.theme.components.dataTable.TablePaginationView.Container.tabletView.width};
      .Pagniation__Control {
        width: ${t.theme.components.dataTable.TablePaginationView.Container.tabletView.paginationControl.width};
      }
      .DropdownBase__wrapper {
        width: unset;
      }
    }
    `}
`, st = l.span`
  ${(t) => `
    width: ${t.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.width};
    font-family: ${t.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.fontFamily};
    color: ${t.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.color};
    font-size: ${t.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.fontSize};
    font-weight: ${t.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.fontWeight};
    line-height: ${t.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.lineHeight};
    `}
`, rt = ({
  itemsPerPage: t = 1,
  totalItems: s = 10,
  siblingCount: p = 2,
  page: $ = 1,
  onPageChange: m,
  variant: f = "default",
  children: h
}) => {
  var d, x, y, D, w, k, L, I;
  const c = K({ label: "Pagination" }), o = U(
    h,
    {
      PreviousButton: j.PreviousButton,
      NextButton: j.NextButton
    },
    U.PickType.LAST
  ), [i, u] = A(1), a = Math.ceil(s / t);
  H(() => {
    u($);
  }, [$]);
  const P = (e) => {
    u(e), m && m(e);
  }, T = () => {
    if (i > 1) {
      const e = i - 1;
      u(e), m && m(e);
    }
  }, v = () => {
    if (i < a) {
      const e = i + 1;
      u(e), m && m(e);
    }
  }, S = X({
    totalCount: a,
    siblingCount: p,
    currentPage: i
  });
  return /* @__PURE__ */ b("nav", { ...c, children: [
    f !== "default" ? /* @__PURE__ */ b(Y, { children: [
      /* @__PURE__ */ n(
        O,
        {
          size: "medium",
          variant: "outline",
          leftIcon: /* @__PURE__ */ n(g, { name: "caretLeft" }),
          isDisabled: i === 1,
          onClick: T,
          accessibilityOptions: { ariaLabel: "Previous" },
          ...(d = o.PreviousButton) == null ? void 0 : d.props,
          children: ((x = o.PreviousButton) == null ? void 0 : x.props.children) || "Previous"
        }
      ),
      /* @__PURE__ */ n(
        O,
        {
          size: "medium",
          variant: "outline",
          rightIcon: /* @__PURE__ */ n(g, { name: "caretRight" }),
          isDisabled: i === a,
          onClick: v,
          accessibilityOptions: { ariaLabel: "Next" },
          ...(y = o.NextButton) == null ? void 0 : y.props,
          children: ((D = o.NextButton) == null ? void 0 : D.props.children) || "Next"
        }
      )
    ] }) : /* @__PURE__ */ b(Z, { children: [
      /* @__PURE__ */ n(
        N,
        {
          tabIndex: 0,
          onClick: T,
          disabled: i === 1,
          "aria-label": "prev",
          ...(w = o.PreviousButton) == null ? void 0 : w.props,
          children: /* @__PURE__ */ n(
            g,
            {
              name: "caretLeft",
              size: "l"
            }
          )
        }
      ),
      /* @__PURE__ */ b(tt, { children: [
        i,
        " of ",
        a
      ] }),
      /* @__PURE__ */ n(
        N,
        {
          onClick: v,
          disabled: i === a,
          tabIndex: 0,
          "aria-label": "next",
          ...(k = o.NextButton) == null ? void 0 : k.props,
          children: /* @__PURE__ */ n(
            g,
            {
              name: "caretRight",
              size: "l"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ b(et, { children: [
      /* @__PURE__ */ n(M, { children: /* @__PURE__ */ n(
        N,
        {
          tabIndex: 0,
          onClick: T,
          disabled: i === 1,
          "aria-label": "prev",
          ...(L = o.PreviousButton) == null ? void 0 : L.props,
          children: /* @__PURE__ */ n(
            g,
            {
              name: "caretLeft",
              size: "l"
            }
          )
        }
      ) }),
      S.map((e, r) => e === W ? /* @__PURE__ */ n(M, { children: /* @__PURE__ */ n(it, { children: /* @__PURE__ */ n(
        g,
        {
          name: "moreVertical",
          height: "10px",
          width: "10px"
        }
      ) }) }, r) : /* @__PURE__ */ n(M, { children: /* @__PURE__ */ n(
        nt,
        {
          $isActive: e === i,
          onClick: () => P(e),
          tabIndex: e === i ? -1 : 0,
          onKeyDown: (C) => {
            (C.code === "Enter" || C.code === "Space") && P(e);
          },
          className: "PageLink",
          children: e
        }
      ) }, r)),
      /* @__PURE__ */ n(M, { children: /* @__PURE__ */ n(
        N,
        {
          onClick: v,
          disabled: i === a,
          tabIndex: 0,
          "aria-label": "next",
          ...(I = o.NextButton) == null ? void 0 : I.props,
          children: /* @__PURE__ */ n(
            g,
            {
              name: "caretRight",
              size: "l"
            }
          )
        }
      ) })
    ] })
  ] });
}, j = ({
  totalItems: t,
  page: s,
  initialItemsPerPage: p = 5,
  itemsPerPage: $,
  onItemsPerPageChange: m,
  onPageChange: f,
  showTotalItems: h = !1,
  showPerPageOption: c = !1,
  perPageLabel: o = "per page",
  itemsLabel: i = "of items",
  placeholder: u,
  exceedOverflow: a = !1,
  children: P,
  ...T
}) => {
  const [v, S] = A([]), [d, x] = A(""), [y, D] = A(!1), w = Q(J("pagination"));
  H(() => {
    if (p) {
      const e = [];
      for (let r = 1; r <= 5; r++)
        e.push({
          label: `${p * r} ${o}`,
          value: `${p * r}`
        });
      S(e), x(`${$} ${o}`);
    }
  }, [$, p]);
  const k = E("combobox", {
    ariaExpanded: y,
    ariaHasPopup: "listbox",
    ariaControls: `list-${w.current}`
  }), L = E("input", { ariaLabel: `${d}`, ariaLabelledBy: void 0 }), I = () => {
    const e = s || 1, r = parseInt(d) || 1, C = (e - 1) * r, R = C + r, _ = i.split(" ");
    return `${C + 1} - ${R > t ? t : R} ${_[0]} ${t} ${_[1]}`;
  };
  return /* @__PURE__ */ b(ot, { $singleChild: !(c || h), children: [
    !!(c || h) && /* @__PURE__ */ b(at, { children: [
      c && /* @__PURE__ */ b(
        z,
        {
          exceedOverflow: a,
          menuDirection: a ? "auto" : "down_left",
          menuOpen: y,
          handleMenuOpen: (e) => {
            D(e);
          },
          uniqueIdentifier: w.current,
          closeOnSelect: !0,
          accessibilityOptions: k,
          onChange: (e, r) => {
            `${r.value} ${o}` !== d && (x(r.label), m && m(parseInt(r.value)));
          },
          children: [
            /* @__PURE__ */ n(z.Control, { className: "Pagniation__Control", children: /* @__PURE__ */ n(
              G,
              {
                placeholder: u,
                readOnly: !0,
                value: d,
                id: `control-${w.current}`,
                endAdornmentProp: {
                  endAdornment: y ? /* @__PURE__ */ n(
                    g,
                    {
                      name: "caretUp",
                      style: { pointerEvents: "none" }
                    }
                  ) : /* @__PURE__ */ n(
                    g,
                    {
                      name: "caretDown",
                      style: { pointerEvents: "none" }
                    }
                  )
                },
                ...L
              }
            ) }),
            v.map((e) => /* @__PURE__ */ n(
              z.Item,
              {
                value: e.value,
                label: e.label,
                isSelected: d === e.label
              },
              e.value
            ))
          ]
        }
      ),
      h && /* @__PURE__ */ n(st, { children: I() })
    ] }),
    /* @__PURE__ */ n(
      rt,
      {
        totalItems: t,
        page: s,
        itemsPerPage: parseInt(d) || 1,
        onPageChange: (e) => {
          s !== e && f && f(e);
        },
        ...T,
        children: P
      }
    )
  ] });
};
j.PreviousButton = (t) => /* @__PURE__ */ n("button", { ...t });
j.NextButton = (t) => /* @__PURE__ */ n("button", { ...t });
export {
  j as Pagination
};
